export default "__VITE_ASSET__0af673fa__"